import { QueryResponse as ReportAccessStatus } from 'api/endPoints/GetReportAccessStatus';
import { QueryParams as SetReportAccessStatusPayload, UserAccessStatus } from 'api/endPoints/SetReportAccessStatus';
import { QueryResponse as Tag } from 'api/queries/getReportsTags.query';

import { FormValues } from './ReportSettingsModal.types';

export const getInitialFormValues = (
    tags: Tag[] | undefined,
    reportAccessStatus: ReportAccessStatus | undefined,
): FormValues => {
    if (!reportAccessStatus) {
        return {
            selectedTags: [],
            userAccessList: [],
            allUsersAccess: false,
            notifyAllUsersOnUpload: false,
            accessListOption: 'whole',
        };
    }

    // set initial tags
    const selectedTags = reportAccessStatus.tags ?? [];
    const allUsersAccess = reportAccessStatus.reportAccessStatus.allUsersAccess;

    const notifyAllUsersOnUpload = reportAccessStatus.reportAccessStatus.notifyAllUsersOnUpload;

    return {
        selectedTags,
        userAccessList: reportAccessStatus.reportAccessStatus.userAccessStatusList,
        allUsersAccess,
        notifyAllUsersOnUpload,
        accessListOption: allUsersAccess ? 'whole' : 'specific',
    };
};

export const convertFormDataToAPIPayload = (formValues: FormValues, reportId: number): SetReportAccessStatusPayload => {
    const tagIds = formValues.selectedTags.map((tag) => {
        return {
            id: tag.id,
        };
    });
    const userAccessStatusList: UserAccessStatus[] = formValues.userAccessList.map((user) => {
        return {
            hasAccess: user.hasAccess,
            notifyOnUpload: user.notifyOnUpload,
            userName: user.userName,
            canHaveAccess: user.canHaveAccess,
        };
    });

    return {
        reportId,
        tags: tagIds,
        reportAccessStatus: {
            allUsersAccess: formValues.allUsersAccess,
            notifyAllUsersOnUpload: formValues.notifyAllUsersOnUpload,
            userAccessStatusList,
        },
    };
};
